export default __webpack_public_path__ + "static/media/pic4.45a0fc9c.jpg";